<template>
  <ul class="mm-nav" :class="{'sort':sortnav}">
    <li v-if="item.path != '/' && item.isnav" :class="{'mm-nav-open':openindex == index}" @click="opennav(index)" v-for="(item,index) in navitems" :key="index">
      <div class="mm-item">
        <div class="mm-titlebox"><i class="mm-navico" :class="item.ico"></i><span class="mm-nav-title">{{item.name}}</span></div>
        <i class="mm-nav-arrow  el-icon-arrow-down"></i>
      </div>
      <div :style="{'height':item.childboxheight}" class="childbox">
        <ul class="mm-child-nav">
          <li v-if="child.isnav" ref="mmnavchildli" :class="{'mm-nav-active':navactive == child.id}" v-for="(child,i) in item.sub" :key="i" @click="gotoruter(child.path,child.id)">{{child.meta.title}}</li>
        </ul>
      </div>
    </li>
    <li @click="logout">
      <div class="mm-item">
        <div class="mm-titlebox"><i class="mm-navico el-icon-warning-outline"></i><span class="mm-nav-title">退出</span></div>
      </div>
    </li>
  </ul>
</template>
<script>
export default {
  props: ['gohome', 'sortnav'],
  data () {
    return {
      navitems: {},
      navactive: -1,
      openindex: -1
    };
  },
  watch: {
    gohome (v) {
      this.navactive = -1;
      this.openindex = -1;
      if (this.sortnav) {
        this.sortnavinit();
      } else {
        this.bignavinit();
      }
    },
    sortnav (v) {

      if (v) {
        this.sortnavinit();
      } else {
        this.bignavinit();
      }
    }
  },
  methods: {
    sortnavinit () {
      let navitems = this.navitems;
      let childliheight = 50;
      navitems = navitems.map((r, i) => {
        let childlinum = navitems[i].sub.length;
        r.childboxheight = childliheight * childlinum + 'px';
        return r;
      });
      this.navitems = navitems;
    },
    bignavinit () {
      let navitems = this.navitems;
      navitems = navitems.map((r, i) => {
        if (i != this.openindex) {
          r.childboxheight = 0;
        }
        return r;
      });
      this.navitems = navitems;
    },
    logout () {
      this.$confirm('確認退出系統嗎？', '詢問', {
        confirmButtonText: '確認',
        cancelButtonText: "取消",
        type: 'info'
      }).then(() => {
        websocket.close();
        sessionStorage.clear();
        // 表單提交數據前驗證 valid為驗證結果，驗證通過為true
        this.$router.push({
          name: "Login"
        })
      }).catch(() => {
      });
    },
    opennav (index) {
      if (!this.sortnav) {
        this.openindex = index;
        let childliheight = this.$refs.mmnavchildli[0].scrollHeight;
        let childlinum = this.navitems[index].sub.length;
        let navitems = this.navitems.map((r, i) => {
          if (i == index) {
            r.childboxheight = childliheight * childlinum + 'px';
          } else {
            r.childboxheight = 0;
          }
          return r;
        });
        this.navitems = navitems;
      }
    },
    initdata () {
      let items = this.$router.options.routes;
      let navitems = [];
      items.map((nav) => {
        nav.childboxheight = 0;
        nav.sub = [];
        nav.children.map((s) => {
          if (s.isnav) {
            nav.sub.push(s);
          }
        })
        if (nav.isnav) {
          navitems.push(nav);
        }
      })
      this.navitems = navitems;


    },
    gotoruter (name, activeid) {
      let navitems = this.navitems;
      navitems.map((r, i) => {
        r.sub.map((s) => {
          if (s.id == activeid) {
            this.openindex = i;
            return false;
          };
        })
      });
      this.navactive = activeid;
      this.$router.push(name);
      this.$emit('update:visible', false);
    }
  },

  created () {

    this.initdata();

  }


};
</script>
<style>
.mm-nav {
  width: 250px;
  background: #fff;
  user-select: none;
  transition: all 0.3s;
  position: relative;
  z-index: 10;
}

.mm-nav > li > .mm-item {
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  transition: all 0.3s;
}

.mm-nav > li > .mm-item > .mm-nav-arrow {
  transition: transform 0.3s;
  font-size: 12px;
}

.mm-nav li {
  cursor: pointer;
}

.mm-nav > li > .mm-item:hover {
  background: rgba(204, 204, 204);
}

.mm-titlebox {
  display: flex;
  align-items: center;
  justify-content: center;
}

.mm-nav-title {
  margin-left: 10px;
  white-space: nowrap;
}

.mm-navico {
  font-size: 18px;
  position: relative;
  top: 2px;
}

.childbox {
  height: 0;
  transition: height 0.3s;
  overflow: hidden;
}

.mm-child-nav > li {
  height: 50px;
  white-space: nowrap;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px 0 50px;
  transition: all 0.3s;
}

.mm-child-nav > li:hover {
  background: rgba(204, 204, 204);
}

.mm-nav > li.mm-nav-open > .mm-item {
  background: #66b1ff;
  color: #fff;
}

.mm-nav > li.mm-nav-open > .mm-item > .mm-nav-arrow {
  transform: rotate(180deg);
}

.mm-nav-active {
  background: rgba(64, 158, 255, 0.2);
}

.mm-nav.sort {
  width: 64px;
}

.mm-nav.sort > li {
  position: relative;
}

.mm-nav.sort > li > .mm-item:hover {
  background: #66b1ff;
  color: #fff;
}

.mm-nav.sort .mm-nav-title {
  display: none;
}

.mm-nav.sort .mm-nav-arrow {
  display: none;
}

.mm-nav.sort .childbox {
  color: #fff;
  position: absolute;
  width: 200px;
  height: auto;
  left: 60px;
  top: 0;
  display: none;
}

.mm-nav.sort .childbox .mm-child-nav {
  background: rgba(0, 0, 0, 0.5);
}

.mm-nav.sort > li:hover .childbox {
  display: block;
  padding-left: 10px;
}

.mm-nav.sort .mm-child-nav > li {
  height: 50px;
}

.mm-nav.sort .mm-child-nav > li:hover {
  background: rgba(102, 177, 255, 1);
  color: #fff;
}

.mm-nav.sort .mm-nav-active {
  background: #66b1ff;
  color: #fff;
}

.mm-nav.sort > li.mm-nav-open > .mm-item {
  background: transparent;
  color: #333;
}
.el-drawer__body {
  overflow-x: hidden !important;
}
</style>
